export const INVENTORY_PRICE_FREQUENCIES = ['per_day', 'per_week', 'one_time'];

export const normalizeInventoryPriceFrequency = (value) => {
  const raw = String(value || 'one_time').trim().toLowerCase().replace(/-/g, '_');
  if (raw === 'day' || raw === 'daily' || raw === 'per_day') return 'per_day';
  if (raw === 'week' || raw === 'weekly' || raw === 'per_week') return 'per_week';
  if (raw === 'once' || raw === 'one_time' || raw === 'onetime' || raw === 'flat') return 'one_time';
  return INVENTORY_PRICE_FREQUENCIES.includes(raw) ? raw : 'one_time';
};

/** Translate-aware label key suffix: partnerInventory.frequency.per_day etc. */
export const inventoryPriceFrequencyKey = (value) => (
  `partnerInventory.frequency.${normalizeInventoryPriceFrequency(value)}`
);

export const formatInventoryPriceLabel = (item, t) => {
  const amount = Number(item?.defaultPrice ?? item?.default_price ?? 0);
  const currency = item?.currency || 'USD';
  const frequency = normalizeInventoryPriceFrequency(item?.priceFrequency ?? item?.price_frequency);
  const money = `${amount.toFixed(2)} ${currency}`;
  if (frequency === 'one_time') return money;
  return `${money} · ${t(inventoryPriceFrequencyKey(frequency))}`;
};
